import errorMessages from './errorMessages'

const errorCodeToMessage = new Map([
  [3043, errorMessages.statusNotFoundError],
  [3021, errorMessages.somethingWentWrong],
  [3034, errorMessages.sessionNotFoundError],
  [3026, errorMessages.insufficientFundsError],
  [2005, errorMessages.userNotFoundError],
  [3029, errorMessages.unkownOperatorError],
  [3010, errorMessages.invalidCurrencyError],
  [3030, errorMessages.duplicateTransactionIDError],
  [3024, errorMessages.debitTransactionNotFoundError],
  [3023, errorMessages.invalidAmountError],
  [3001, errorMessages.requestInputValidationError],
  [3002, errorMessages.responseValidationError],
  [3003, errorMessages.socketRequestInputValidationError],
  [3004, errorMessages.socketResponseValidationError],
  [3005, errorMessages.internalServerError],
  [3006, errorMessages.invalidSocketArgumentError],
  [3007, errorMessages.invalidCredentials],
  [3008, errorMessages.invalidToken],
  [3011, errorMessages.operatorPlayerUnAuthenticated],
  [3012, errorMessages.invalidGameTypeError],
  [3013, errorMessages.invalidGameRoundError],
  [3014, errorMessages.noRoundRunningError],
  [3015, errorMessages.noPlacedBetFoundError],
  [3016, errorMessages.noUserFoundError],
  [3017, errorMessages.notEnoughBalanceError],
  [3018, errorMessages.autoRateIsInvalidError],
  [3019, errorMessages.betAmountIsNotInLimitError],
  [3020, errorMessages.userNotAbove18YearsError],
  [3022, errorMessages.invalidCredentialError],
  [3025, errorMessages.invalidTransactionError],
  [3027, errorMessages.blockedTransactionError],
  [3028, errorMessages.invalidOperatorIdError],
  [3031, errorMessages.betLimitReachedError],
  [3032, errorMessages.lossLimitReachedError],
  [3033, errorMessages.profitLimitReachedError],
  [3036, errorMessages.invalidSignature],
  [3042, errorMessages.invalidDebitOperatorResponse],
  [3044, errorMessages.gameNotActive],
  [3045, errorMessages.minAutoRateNotAchieved],
  [3046, errorMessages.crossGameTileAlreadyOpenedError],
  [3047, errorMessages.crossGameNoOpenedTileFoundError],
  [3048, errorMessages.invalidTileError],
  [3049, errorMessages.invalidLaneError],
  [3050, errorMessages.crossGameAutoBetNotCompletedError],
  [3051, errorMessages.invalidDifficultyLevelError],
  [3052, errorMessages.crossGamePreviousRoundNotCompletedError],
  [3053, errorMessages.tryAgainError],
  [3054, errorMessages.invalidSessionError],
  [3055, errorMessages.invalidSegmentsError],
  [3056, errorMessages.invalidRiskLevelError],
  [3057, errorMessages.invalidGameIdError],
  [3058, errorMessages.invalidRoundError],
  [3059, errorMessages.roundAlreadyFinishedError],
  [3060, errorMessages.placeBetCanNotBeenCanceledError],
  [3061, errorMessages.autoBetNotCompletedError],
  [3062, errorMessages.tileAlreadyOpenedError],
  [3063, errorMessages.invalidTargetMultiplierError],
  [3064, errorMessages.initialCardRangeError]
])

export default errorCodeToMessage
